import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStructure = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "structure",
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13007",
			"data-name": "Path 13007",
			d: "M0,0H16V16H0Z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13008",
			"data-name": "Path 13008",
			d: "M13.453,7.7,7.5,4.21",
			transform: "translate(-2.5 -1.403)",
			fill: "none",
			stroke: "#666",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13009",
			"data-name": "Path 13009",
			d: "M16.43,9.44v6.9",
			transform: "translate(-5.477 -3.147)",
			fill: "none",
			stroke: "#666",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13010",
			"data-name": "Path 13010",
			d: "M9,15.407,3,12",
			transform: "translate(-1 -4)",
			fill: "none",
			stroke: "#666",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13011",
			"data-name": "Path 13011",
			d: "M12,15.38l6-3.46",
			transform: "translate(-4 -3.973)",
			fill: "none",
			stroke: "#666",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1,
			fillRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13012",
			"data-name": "Path 13012",
			d: "M7.5,7.67l6-3.46",
			transform: "translate(-2.5 -1.403)",
			fill: "none",
			stroke: "#666",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1,
			fillRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13013",
			"data-name": "Path 13013",
			d: "M7.5,9.4v6.927",
			transform: "translate(-2.5 -3.133)",
			fill: "none",
			stroke: "#666",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13014",
			"data-name": "Path 13014",
			d: "M3.278,6.965l5.815,3.357,5.814-3.357",
			transform: "translate(-1.093 -2.322)",
			fill: "none",
			stroke: "#666",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1,
			fillRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13015",
			"data-name": "Path 13015",
			d: "M12,12v6.713",
			transform: "translate(-4 -4)",
			fill: "none",
			stroke: "#666",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13016",
			"data-name": "Path 13016",
			d: "M15,11.307V5.979a1.385,1.385,0,0,0-.693-1.2L9.693,2.115a1.386,1.386,0,0,0-1.385,0L3.693,4.779A1.385,1.385,0,0,0,3,5.979v5.328a1.385,1.385,0,0,0,.693,1.2l4.615,2.664a1.386,1.386,0,0,0,1.385,0l4.615-2.664a1.385,1.385,0,0,0,.693-1.2Z",
			transform: "translate(-1 -0.643)",
			fill: "none",
			stroke: "#666",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1,
			fillRule: "evenodd"
		})
	]
});
export default SvgStructure;
